//export const API_URL = 'https://api.example.com';
//export const API_SEARCH  = 'http://127.0.0.1:8000/api/search';
export const API_SEARCH  = 'https://api.hospitalangeldelmar.com.mx/api/search';
//export const API_CONTACT  = 'http://127.0.0.1:8000/api/contact';
//export const API_CONTACT  = 'https://api.hospitalangeldelmar.com.mx/api/contact';
export const API_CONTACT  = 'https://api.hospitalangeldelmar.com.mx/SendEmail.php';
export const SITE_DOMAIN  = '.hospitalangeldelmar.com.mx';
//export const SITE_DOMAIN  = '.localhost';
export const LOCALE_COOKIE_NAME  = 'localeCookie';
